<template>
  <fin-dialog v-model="show" class="regulationsDialog" fullscreen hideCloseButton persistent
              style="z-index: 540 !important">

    <template>
      <fin-regulations class="fin-reg-content"/>
    </template>

  </fin-dialog>
</template>

<script>
import {mapGetters} from "vuex"
import FinRegulations from "@/views/protected/finRegulations"

export default {
  name: "FinRegulationsCheck",
  components: {FinRegulations},
  data() {
    return {
      show: false,
    }
  },
  computed: {
    ...mapGetters('auth', ['user', 'profile', 'userOnboardingData']),
    isIdle() {
      const hasDocumentsToAccept = this.profile ? this.profile.documentsToAccept.length > 0 : false
      console.log("hasDocumentsToAccept", hasDocumentsToAccept)
      console.log("userOnboardingData", this.userOnboardingData)
      const hasBeenInFastTrack = this.userOnboardingData !== null
      return hasDocumentsToAccept && hasBeenInFastTrack // this.$store.state.profile.documentsToAccept.length
    }
  },
  watch: {
    isIdle: {
      handler(val) {
        this.show = val
      },
      immediate: true
    },
  },
}
</script>

<style lang="scss" scoped>

::v-deep .v-dialog, regulationsDialog {
  z-index: 504 !important
}
</style>
